import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { couponRedeemMock } from '../model/dataModel';
import { ApiService, ILicenseCar } from './api.service';
import { IconfirmOTP, IEcoupon } from '../model/ecouponInterface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NG_APP_API_ENDPOINT } from '@web-nx-ng-tsc/shared-constant';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({
  providedIn: 'root',
})
export class RestApiService extends ApiService {
  private readonly http = inject(HttpClient);
  private readonly loggingService = inject(LoggingService);

  getAllLicensCar(): Observable<ILicenseCar> {
    return of(couponRedeemMock).pipe(
      tap((res) => this.loggingService.warn('GET | getAllcouponRedeemMock[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  postForm(form: IEcoupon) {
    this.loggingService.log('PostForm[RestApiService]', form);
    return this.http.post(`${NG_APP_API_ENDPOINT}/coupon/redeem`, form).pipe(
      tap((res) => this.loggingService.log('TAP | PostForm[RestApiService] :', res)),
      map((res: any) => res),
      tap((res) => this.loggingService.log('TAP | PostFormMSG[RestApiService] res.msg :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | PostForm[RestApiService] :', error);
        return throwError(() => error);
      })
    );
  }
  getProvince() {
    return this.http.get(`${NG_APP_API_ENDPOINT}/provinces`).pipe(
      map((res: any) => res.data),
      // map((res: any) => res.data),
      tap((res: any) => this.loggingService.warn('[GET] getProvincesLists :: =>', res))
    );
  }
  confirmOTP(otp: IconfirmOTP) {
    // let params = new HttpParams();
    // Object.entries(otp).forEach(([key, value]) => {
    //   if (value) {
    //     params = params.set(key, value);
    //   }
    // });
    this.loggingService.log('otp[RestApiService]', otp);
    // this.loggingService.log(`${BASE_URL}/coupon/otp-confirm`);
    return this.http.post(`${NG_APP_API_ENDPOINT}/coupon/otp-confirm`, otp).pipe(
      tap((res) => this.loggingService.log('TAP | otp-confirm[RestApiService] :', res)),
      map((res: any) => res),
      tap((res) => this.loggingService.log('TAP | otp-confirm[RestApiService] res.msg :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | otp-confirm[RestApiService] :', error);
        return throwError(() => error);
      })
    );
  }

  getDetailCampaign(id: string, brand: string) {
    const params = new HttpParams().set('campaign_id', id);
    // Object.entries(otp).forEach(([key, value]) => {
    //   if (value) {
    //     params = params.set(key, value);
    //   }
    // });
    this.loggingService.log('getDetailCampaign[RestApiService]', params);
    this.loggingService.log(`${NG_APP_API_ENDPOINT}/campaign?campaign_id=${id}`);
    return this.http.get(`${NG_APP_API_ENDPOINT}/campaign?campaign_id=${id}&brand=${brand}`).pipe(
      tap((res) => this.loggingService.log('TAP | getDetailCampaign[RestApiService] :', res)),
      map((res: any) => res),
      tap((res) => this.loggingService.log('TAP | getDetailCampaign[RestApiService] res.msg :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getDetailCampaign[RestApiService] :', error);
        return throwError(() => error);
      })
    );
  }
  getCheckCampaignFull(id: string) {
    return this.http.get(`${NG_APP_API_ENDPOINT}/coupon/full?campaign_id=${id}`).pipe(
      tap((res) => this.loggingService.log('TAP | getCheckCampaignFull[RestApiService] :', res)),
      map((res: any) => res),
      tap((res) => this.loggingService.log('TAP | getCheckCampaignFull[RestApiService] res.msg :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getCheckCampaignFull[RestApiService] :', error);
        return throwError(() => error);
      })
    );
  }
  getCheckCampaignExpire(id: string) {
    return this.http.get(`${NG_APP_API_ENDPOINT}/campaign/expire?campaign_id=${id}`).pipe(
      tap((res) => this.loggingService.log('TAP | getCheckCampaignExpire[RestApiService] :', res)),
      map((res: any) => res),
      tap((res) => this.loggingService.log('TAP | getCheckCampaignExpire[RestApiService] res.msg :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getCheckCampaignExpire[RestApiService] :', error);
        return throwError(() => error);
      })
    );
  }
}
